import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Link } from "gatsby"
import React from "react"
import { Badge, Card } from "react-bootstrap"

export default props => {
  return (
    <Card className="card-blog" as={Link} to={props.to}>
      <Card.Body>
        <div className="d-flex justify-content-between align-items-center mb-2">
          <small className="blog-date">{props.date}</small>
          {props.time && (
            <small className="blog-read-time">
              <FontAwesomeIcon size="sm" icon={["fas", "clock"]} className="mr-1" />
              {props.time}
            </small>
          )}
        </div>
        <Card.Title as="h5" className="mb-2">{props.title}</Card.Title>
        <div className="mb-3">
          {props.tags && props.tags.map(tag => (
            <Badge key={tag} pill className="px-2 mr-1 badge-violet">
              {tag}
            </Badge>
          ))}
        </div>
        <Card.Text>{props.excerpt}</Card.Text>
      </Card.Body>
    </Card>
  )
}
